import { jsx } from 'react/jsx-runtime';

const SvgNavMenuAlt = (props) => jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: jsx("path", { fill: "#2D2E2E", d: "M20 5H4v2h16V5ZM4 14.43l16-2.83V9.57L4 12.4v2.03ZM20 17H4v2h16v-2Z" }) }));

export { SvgNavMenuAlt as default };
//# sourceMappingURL=NavMenuAlt.es.js.map
